import { render } from "./CardTeam.vue?vue&type=template&id=937e03e2&scoped=true"
import script from "./CardTeam.vue?vue&type=script&lang=js"
export * from "./CardTeam.vue?vue&type=script&lang=js"

import "./CardTeam.vue?vue&type=style&index=0&id=937e03e2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-937e03e2"]])

export default __exports__